module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/babaffcbf18924e42abcd841cfe05724.png";